export const DEFAULT_CAMPAIGN_TIMEZONE = 'America/New_York';

export const CAMPAIGN_TIMEZONE_COPY = {
  label: 'Campaign Time Zone',
  columnHeader: 'Time Zone',
  placeholder: 'Select a time zone',
  description: 'Line item schedules and delivery reporting use this time zone.',
  lockedTooltip: 'The campaign time zone cannot be changed after the campaign is activated.',
  nonDraftLineItemsTooltip: 'The campaign time zone cannot be changed once a line item is no longer in Draft.',
  phaseOneTooltip: 'Campaigns currently deliver in Eastern Time.',
  noPermissionTooltip: 'You are not permitted to update this campaign.',
  readOnlyTooltip: 'This campaign is read-only.',
  inheritedHint: 'Inherited from the Ad Account default.',
  updateSuccess: 'Campaign time zone successfully updated',
  updateError: 'Unable to update campaign time zone.',
  unsupportedValue: 'Select a supported time zone.',
  bannerPrefix: 'Ads will run based on the campaign time zone:',
} as const;
